module.exports = __webpack_public_path__ + "media/images/icon_btn_star-e70d0742d24270bc4185b55d46e1b367.png";